<template xmlns:v-on="http://www.w3.org/1999/xhtml">
  <div class="row-col">

    <a
      data-dismiss="modal"
      class="pull-right text-muted text-lg p-a-sm m-r-sm">×</a>
    <div class="p-a b-b">
      <span class="h5 text-capitalize">{{ tagExists(tag.id) ? 'Update' : 'Create' }} Tag</span>
    </div>

    <div class="row-row">
      <div class="row-body">
        <div class="row-inner">
          <div class="p-a">

            <div
              :class="{'invalid':errors.has('name')}"
              class="md-form-group">
              <input
                v-validate="'required'"
                :disabled="loading"
                v-model="tag.name"
                type="text"
                name="name"
                class="md-input"
                placeholder="Required">
              <label>Name</label>
              <span
                v-show="errors.has('name')"
                class="form-error-msg">{{ errors.first('name') }}</span>
            </div>

            <div
              class="md-form-group">
              <input
                :disabled="loading"
                v-model="tag.code"
                type="text"
                name="code"
                class="md-input">
              <label>Code</label>
            </div>

            <div
              :class="{'invalid':errors.has('description')}"
              class="md-form-group">
              <input
                :disabled="loading"
                v-model="tag.description"
                type="text"
                name="description"
                class="md-input">
              <label>Description</label>
              <span
                v-show="errors.has('description')"
                class="form-error-msg">{{ errors.first('description') }}</span>
            </div>

            <time-picker
              id="available_from"
              ref="available_from"
              :date-to-compare="tag.available_to"
              :rules="{ date_format: 'h:mm A'}"
              :external-error="availableFromError"
              name="Available from"
              label="Available from"
              input-to-compare="Available to"
              @onChange="setAvailableFrom"
            />

            <time-picker
              id="available_to"
              ref="available_to"
              :date-to-compare="tag.available_from"
              :rules="{ date_format: 'h:mm A'}"
              :icon="'&#xE426;'"
              :external-error="availableToError"
              label="Available to"
              name="Available to"
              @onChange="setAvailableTo"
            />

            <div class="form-group p-b-sm">
              <label class="typo__label multiselect-label">Parent Tag</label>
              <multiselect
                id="ajaxTag"
                v-model="tag.parent"
                :options="tags"
                :loading="ajaxTagLoading"
                placeholder="Type to search"
                label="name"
                track-by="id"
                @search-change="loadTags"/>
            </div>

            <div class="form-group p-b-sm">
              <a
                data-dismiss="modal"
                class="pull-right m-r-sm">{{ tag.products.length }} products selected</a>
              <div class="">
                <span class="typo__label multiselect-label">Product</span>
              </div>
              <div class="p-t-sm">
                <button
                  class="btn btn-sm btn-block white"
                  data-toggle="modal"
                  data-target="#m-a-a"
                  ui-toggle-class="fade-up-big"
                  ui-target="#animate"
                  @click="show_product_list()">Select products</button>
              </div>
            </div>

            <div class="form-group p-b-sm">
              <modifier-selector v-model="tag.modifier_sets"/>
            </div>

            <div class="form-group">
              <label>Options</label>
              <div class="form-group">
                <p>
                  <label class="md-switch">
                    <input
                      :disabled="loading"
                      v-model="tag.hidden_tag"
                      type="checkbox"
                      class="has-value">
                    <i class="indigo"/>
                    Hide tag
                  </label>
                </p>
                <p>
                  <small>The tag will hidden from Central and Waiter.</small>
                </p>
              </div>
              <div class="form-group">
                <p>
                  <label class="md-switch">
                    <input
                      :disabled="loading"
                      v-model="tag.hidden_products"
                      type="checkbox"
                      class="has-value">
                    <i class="indigo"/>
                    Hide products
                  </label>
                </p>
                <p>
                  <small>The product assigned to this tag will hidden from Central and Waiter.</small>
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="row no-gutter b-t">
      <div class="col-md-5">
        <div class="p-a text-left">
          <label
            v-if="!tagExists(tag.id)"
            class="md-switch">
            <input
              v-model="toggle"
              type="checkbox">
            <i class="indigo"/> Keep form open
          </label>
        </div>
      </div>
      <div class="col-md-7">
        <div class="p-a">
          <div class="text-right">
            <button
              :disabled="loading"
              class="btn btn-fw white"
              data-dismiss="modal">Cancel</button>
            <button
              :disabled="loading || !canManageItems || readOnlyItems"
              class="btn btn-fw primary"
              @click="submit()">Save</button>
          </div>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
import ModifierSelector from '../item/modifier-selector';
import PermissionMixin from '../item-permission';

export default {
    components: {
        ModifierSelector,
    },

    mixins: [PermissionMixin],

    props: {
        tag: {
            type: Object,
            required: true,
        },
    },

    data() {
        return {
            toggle: false,
            ajaxTagLoading: false,
            multiselect_query_limit: 30,
            ajaxProductLoading: false,
            api_item_select: Laroute.route('franchise.vue.products'),
            api_tag_select: Laroute.route('franchise.vue.tags'),
            items: [],
            tags: [],
            loading: false,
            availableFromError: '',
            availableToError: '',
        };
    },

    watch: {
        toggle(data) {
            localStorage.setItem('toggle', data);
        },
    },

    mounted() {
        var that = this;
        this.loadProducts(null);
        this.loadTags(null);

        $('#tag-popup').on('hidden.bs.modal', function(e) {
            that.errors.clear();
            that.clearAvailableTimeErrors();
        });

        if (localStorage.getItem('toggle')) {
            this.toggle = JSON.parse(localStorage.getItem('toggle'));
        }
    },

    methods: {
        submit() {
            var that = this;
            this.loading = true;

            this.$validator.validateAll().then(result => {
                const hasAvailableTimeError = this.validateAvailableTimes();
                if (result && !hasAvailableTimeError) {
                    let products = this.tag.products.map(function(obj) {
                        return obj.id;
                    });
                    this.converTimeToHHMMSS();
                    let data = {
                        name: this.tag.name,
                        parent_id:
                            this.tag.parent == null ? null : this.tag.parent.id,
                        code: this.tag.code,
                        available_from: this.tag.available_from,
                        available_to: this.tag.available_to,
                        description: this.tag.description,
                        products: products,
                        modifier_sets: this.tag.modifier_sets.map(
                            obj => obj.id,
                        ),
                        hidden_tag: this.tag.hidden_tag,
                        hidden_products: this.tag.hidden_products,
                    };
                    that.$http.post(that.getTagApi(that.tag.id), data).then(
                        response => {
                            if (response.status == '200') {
                                if (!that.tagExists(that.tag.id)) {
                                    that.$parent.init_tag();
                                }

                                if (!that.toggle) {
                                    $('#tag-popup').modal('hide');
                                }

                                let msg =
                                    'Tag successfully ' +
                                    (!that.tagExists(that.tag.id)
                                        ? 'created'
                                        : 'updated');
                                toastr.success(msg);

                                this.$emit('tag-saved');
                            }

                            that.loading = false;
                        },
                        error => {
                            toastr.error(error.statusText);
                            that.loading = false;
                        },
                    );
                } else {
                    that.loading = false;
                }
            });
        },

        setAvailableFrom(date) {
            if (!date) {
                this.tag.available_from = null;
            } else {
                this.tag.available_from = date.format('h:mm A');
            }
            this.validateAvailableTimes();
        },

        setAvailableTo(date) {
            if (!date) {
                this.tag.available_to = null;
            } else {
                this.tag.available_to = date.format('h:mm A');
            }
            this.validateAvailableTimes();
        },

        clearTimePicker() {
            this.$refs.available_to.clear();
            this.$refs.available_from.clear();
        },

        setTimePickerValue(tag) {
            if (!_.isEmpty(tag.available_from)) {
                this.$refs.available_from.setValue(tag.available_from);
            } else {
                this.$refs.available_from.clear();
            }

            if (!_.isEmpty(tag.available_to)) {
                this.$refs.available_to.setValue(tag.available_to);
            } else {
                this.$refs.available_to.clear();
            }
        },

        converTimeToHHMMSS() {
            if (!_.isEmpty(this.tag.available_from)) {
                this.tag.available_from = moment(
                    this.tag.available_from,
                    'h:mm A',
                ).format('HH:mm:ss');
            }
            if (!_.isEmpty(this.tag.available_to)) {
                this.tag.available_to = moment(
                    this.tag.available_to,
                    'h:mm A',
                ).format('HH:mm:ss');
            }
        },

        clearAvailableTimeErrors() {
            this.availableFromError = '';
            this.availableToError = '';
        },

        validateAvailableTimes() {
            this.clearAvailableTimeErrors();
            const availableFrom = this.tag.available_from;
            const availableTo = this.tag.available_to;
            let hasError = false;

            if (!_.isEmpty(availableTo) && _.isEmpty(availableFrom)) {
                this.availableFromError =
                    'Available from is required when Available to is set.';
                hasError = true;
            }

            if (!_.isEmpty(availableFrom) && _.isEmpty(availableTo)) {
                this.availableToError =
                    'Available to is required when Available from is set.';
                hasError = true;
            }

            return hasError;
        },

        isValidTime() {
            return (
                this.$refs.available_from.hasError() ||
                this.$refs.available_to.hasError()
            );
        },

        tagExists(id) {
            return id != 0 && id != undefined;
        },

        getTagApi(id) {
            if (this.tagExists(id)) {
                return Laroute.route('franchise.inventory.tags.update', {
                    id: id,
                });
            } else {
                return Laroute.route('franchise.inventory.tags.store');
            }
        },

        loadProducts: _.debounce(function(query) {
            let options = {
                params: {
                    query: query,
                    limit: this.multiselect_query_limit,
                },
            };

            this.ajaxProductLoading = true;
            this.$http.get(this.api_item_select, options).then(response => {
                this.items = response.data.data;
                this.ajaxProductLoading = false;
            });
        }, 500),

        loadTags: _.debounce(function(query) {
            let options = {
                params: {
                    query: query,
                    limit: this.multiselect_query_limit,
                },
            };

            this.ajaxTagLoading = true;
            this.$http.get(this.api_tag_select, options).then(response => {
                this.tags = response.data.data.filter(
                    tag => tag.id != this.tag.id,
                );
                this.ajaxTagLoading = false;
            });
        }, 500),

        show_product_list() {
            this.$emit('showupProduct', this.tag);
        },
    },
};
</script>



// WEBPACK FOOTER //
// resources/assets/js/franchise_component/inventory/tag/vuetabletag_form.vue